import createUserData from '@app/state/data/partials/user'
import createMemberData from '@app/state/data/partials/member'
import createAnswerData from '@app/state/data/partials/answers'
import createMembershipTypeData from '@app/state/data/partials/membership_type'
import createPricingData from '@app/state/data/partials/pricing'
import { watch } from 'vue'
import { createMembershipTypeCallback } from './helpers/callbacks/createMembershipTypeCallback'
import { createUserCallback } from './helpers/callbacks/createUserCallback'

const user   = createUserData()
const member = createMemberData()
const answers = createAnswerData()
const membershipType = createMembershipTypeData()
const pricing = createPricingData()

createUserCallback(user, member)
createMembershipTypeCallback(membershipType, answers, pricing)

/**
 * If we're logged in and have memberships already we should be using a different price type to display how much we should pay
 */
watch(member.has_memberships, (has_memberships) => {
    pricing.price_type.value = has_memberships
        ? 'additional-memberships'
        : 'new-members'
})

export function createData(){
    return {
        user            : user,
        member          : member,
        membership_type : membershipType,
        answers         : answers,
        pricing         : pricing
    }
}